export default function isSelectionEqual(a: SelectionState, b: SelectionState) {
    if (a.type === 'area' && b.type === 'area') {
        return a.localId === b.localId;
    } else if (a.type === 'waypoint' && b.type === 'waypoint') {
        return a.localId === b.localId;
    } else if (a.type === 'track' && b.type === 'track') {
        return a.localId === b.localId;
    } else if (a.type === 'osm' && b.type === 'osm') {
        return a.osmId === b.osmId;
    } else if (a.type === 'interactionSpec' && b.type === 'interactionSpec') {
        return a.feature.id === b.feature.id;
    }
}
